import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from './LanguageContext';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onStartQuiz }) => {
  const { t, language, toggleLanguage } = useTranslation();

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        {/* Language Toggle */}
        <div className="language-toggle">
          <button 
            className={`lang-btn ${language === 'en' ? 'active' : ''}`}
            onClick={() => toggleLanguage('en')}
          >
            English
          </button>
          <button 
            className={`lang-btn ${language === 'ur' ? 'active' : ''}`}
            onClick={() => toggleLanguage('ur')}
            dir="rtl"
          >
            اردو
          </button>
        </div>

        {/* Main Content */}
        <div className="welcome-content" dir={language === 'ur' ? 'rtl' : 'ltr'}>
          {/* Brain Icon */}
          <motion.div 
            className="brain-icon"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 200, damping: 15 }}
          >
            🧠
          </motion.div>

          {/* Headline */}
          <motion.h1 
            className="welcome-headline"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            {t('welcome.headline')}
          </motion.h1>

          {/* Description */}
          <motion.p 
            className="welcome-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            {t('welcome.description')}
          </motion.p>

          {/* Features */}
          <motion.div 
            className="features"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <div className="feature">
              <span className="feature-icon">⏰</span>
              <span>{t('welcome.features.time')}</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🌍</span>
              <span>{t('welcome.features.bilingual')}</span>
            </div>
            <div className="feature">
              <span className="feature-icon">📊</span>
              <span>{t('welcome.features.types')}</span>
            </div>
          </motion.div>

          {/* Start Button */}
          <motion.button 
            className="start-button"
            onClick={onStartQuiz}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {t('welcome.startButton')}
          </motion.button>

          {/* Privacy Note */}
          <motion.p 
            className="privacy-note"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            {t('welcome.privacy')}
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
